(function($, window, undefined) {
    "use strict";

    $(document).ready(function() {
        // Datepicker
        if ($.isFunction($.fn.datepicker)) {
            $(".datepicker").each(function(i, el) {
                var $this = $(el),
                    opts = {
                        format: attrDefault($this, "format", "mm/dd/yyyy"),
                        startDate: attrDefault($this, "startDate", ""),
                        endDate: attrDefault($this, "endDate", ""),
                        daysOfWeekDisabled: attrDefault(
                            $this,
                            "disabledDays",
                            ""
                        ),
                        startView: attrDefault($this, "startView", 0)
                    },
                    $n = $this.next(),
                    $p = $this.prev();

                $this.datepicker(opts);

                if ($n.is(".input-group-addon") && $n.has("a")) {
                    $n.on("click", function(ev) {
                        ev.preventDefault();
                        $this.datepicker("show");
                    });
                }

                if ($p.is(".input-group-addon") && $p.has("a")) {
                    $p.on("click", function(ev) {
                        ev.preventDefault();
                        $this.datepicker("show");
                    });
                }
            });
        }

        // Tile Stats
        $(".tile-stats").each(function(i, el) {
            var $this = $(el),
                $num = $this.find(".num"),
                start = attrDefault($num, "start", 0),
                end = attrDefault($num, "end", 0),
                prefix = attrDefault($num, "prefix", ""),
                postfix = attrDefault($num, "postfix", ""),
                duration = attrDefault($num, "duration", 1000),
                delay = attrDefault($num, "delay", 1000),
                format = attrDefault($num, "format", false);

            if (start < end) {
                if (typeof scrollMonitor == "undefined") {
                    $num.html(prefix + end + postfix);
                } else {
                    var tile_stats = scrollMonitor.create(el);
                    tile_stats.fullyEnterViewport(function() {
                        var o = { curr: start };
                        TweenLite.to(o, duration / 1000, {
                            curr: end,
                            ease: Power1.easeInOut,
                            delay: delay / 1000,
                            onUpdate: function() {
                                $num.html(
                                    prefix +
                                        (format
                                            ? numberWithCommas(
                                                  Math.round(o.curr)
                                              )
                                            : Math.round(o.curr)) +
                                        postfix
                                );
                            }
                        });

                        tile_stats.destroy();
                    });
                }
            }
        });
        if ($.isFunction($.fn.select2)) {
            $(".selector").select2({
                width: "100%",
                theme: "bootstrap"
            });

            $(".department").select2({
                width: "100%",
                theme: "bootstrap",
                createTag: function(params) {
                    var term = $.trim(params.term);

                    if (term === "") {
                        return null;
                    }

                    return {
                        id: 0,
                        text: term
                    };
                }
            });

            $(".department").on("select2:select", function(e) {
                var selection = $(".department")
                    .first()
                    .find(":selected")
                    .first();

                if (selection.val() == 0) {
                    if ($("#department_name").length) {
                        console.log(selection, selection.text());
                        $("#department_name").val(selection.text());
                    } else {
                        var input = $("<input />").attr({
                            type: "hidden",
                            value: selection.text(),
                            name: "department_name",
                            id: "department_name"
                        });

                        $("#register-form-form").append(input);
                    }
                }
            });
        }

        if (window.addToHomescreen != undefined) {
            addToHomescreen({
                displayPace: 0,
                maxDisplayCount: 3
            });
        }
    });
})(jQuery, window);

// Element Attribute Helper
function attrDefault($el, data_var, default_val) {
    if (typeof $el.data(data_var) != "undefined") {
        return $el.data(data_var);
    }

    return default_val;
}
